export default "__VITE_ASSET__5ba7ad98__"